/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useNotify,
  useRefresh,
  Edit,
  useGetOne,
  SelectInput,
  required,
  usePermissions,
} from 'react-admin'
import { userStatusChoises, useStyles } from './common'
import StyledInput from '../../../../components/StyledInput'
import { Divider } from '@mui/material'
import { Chip } from '@material-ui/core'
import RootElement from '../../../../components/RoolElement'

export const EditLandlord = (props) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const classes = useStyles()
  const { data, loading } = useGetOne('users', props.record.landlord_id)
  const [landlord, setLandlord] = useState(null)

  const { permissions } = usePermissions()

  useEffect(() => {
    setLandlord(data)
  })

  const onSuccess = () => {
    notify('Landlord Updated', 'info', { smart_count: 1 }, true)
    refresh()
  }

  const onFailure = (error) => {
    notify(`An Error occured updating landlord  ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const CustomToolbar = (props) => (
    <Toolbar {...props}>
      <SaveButton onSuccess={onSuccess} onFailure={onFailure} disabled={loading || !permissions?.landlord.canEdit} />
      <span className={classes.spacer} />
    </Toolbar>
  )

  return (
    <RootElement>
      <div></div>
      {props.record && (props.record?.phone_no || props.record?.email) && (
        <>
          <Divider textAlign="left">
            <Chip color="primary" variant="outlined" label="Contact details" />
          </Divider>
          <div style={{ width: 'auto', margin: '1em' }}>
            <Typography variant="body2">
              {props.record && (
                <Typography variant="body2">
                  {props.record.name ? 'Name: ' + props.record.name + '; ' : null}
                  {props.record.phone_no ? 'Phone: ' + props.record.phone_no + '; ' : null}
                  {props.record.email ? 'Email: ' + props.record.email + '; ' : null}
                  {props.record.city ? 'City: ' + props.record.city + '; ' : null}
                </Typography>
              )}
            </Typography>
          </div>
        </>
      )}
      <Divider textAlign="left">
        <Chip color="primary" label="Modify Landlord" />
      </Divider>
      <Edit {...props} record={landlord} resource="users">
        <SimpleForm warnWhenUnsavedChanges toolbar={<CustomToolbar />}>
          <FormRow>
            <FormCol xs={1} sm={1} md={1} lg={1}>
              <StyledInput component={TextInput} source="id" label="id" disabled />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol xs={12} sm={12} md={8} lg={2}>
              <StyledInput component={TextInput} source="name.first_name" label="First Name" />
            </FormCol>
            <FormCol xs={12} sm={12} md={8} lg={2}>
              <StyledInput component={TextInput} source="name.last_name" label="Last Name" />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol xs={12} sm={8} md={4} lg={3}>
              <StyledInput component={TextInput} source="contacts.email" label="email" disabled />
            </FormCol>
            <FormCol xs={12} sm={8} md={2} lg={2}>
              <StyledInput component={TextInput} source="contacts.phone_no" label="Phone" />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol lg={2}>
              <StyledInput
                component={SelectInput}
                source="lang"
                validate={[required()]}
                choices={[
                  { id: 'en', name: 'EN' },
                  { id: 'it', name: 'IT' },
                ]}
                label="Language"
              />
            </FormCol>
            <FormCol lg={2}>
              <StyledInput component={SelectInput} source="status" choices={userStatusChoises} />
            </FormCol>
          </FormRow>
        </SimpleForm>
      </Edit>
    </RootElement>
  )
}
